import script from "./DevConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./DevConfig.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__